function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { includes } from 'lodash';
import { withModifiers } from '../../decorators';
import Button from '../button';
import Icon from '../icon';
import Text from '../text';
import Title from '../title';
import { ContextNested, getValidNestedChild } from '../../hooks/context-nested';

var SlicesItem = function SlicesItem(_ref) {
  var Tag = _ref.asTag,
      children = _ref.children,
      className = _ref.className,
      contentClassName = _ref.contentClassName,
      disabled = _ref.disabled,
      icon = _ref.icon,
      iconClassName = _ref.iconClassName,
      onClick = _ref.onClick,
      ctaDisabled = _ref.ctaDisabled,
      title = _ref.title,
      cta = _ref.cta,
      link = _ref.link,
      ctaClassName = _ref.ctaClassName,
      sliceCTAClassName = _ref.sliceCTAClassName,
      titleClassName = _ref.titleClassName,
      price = _ref.price,
      customHtml = _ref.customHtml,
      others = _objectWithoutProperties(_ref, ["asTag", "children", "className", "contentClassName", "disabled", "icon", "iconClassName", "onClick", "ctaDisabled", "title", "cta", "link", "ctaClassName", "sliceCTAClassName", "titleClassName", "price", "customHtml"]);

  var isDisabled = disabled || ctaDisabled; // TODO Current version is non-breaking but ideally it would be preferable to use
  // is-disabled instead of disabled props.

  var sliceClasses = classNames('slice', className, {
    'has-large-icon': iconClassName && includes(iconClassName, 'is-large'),
    'is-disabled': isDisabled
  });
  var contentClasses = classNames('slice-content', contentClassName);
  var ctaClasses = classNames(ctaClassName, {
    'is-outlined is-primary': !link && !ctaClassName,
    'link': link && !ctaClassName
  });
  var sliceCTAClasses = classNames('slice-call-to-action', sliceCTAClassName);
  var titleClasses = classNames(titleClassName);

  var _contextNested = useContext(ContextNested);

  var _Tag = getValidNestedChild(_contextNested.isNestedInParent, Tag);

  var ctaType;

  if (cta) {
    ctaType = React.createElement(Button, {
      className: ctaClasses,
      disabled: isDisabled
    }, cta);
  } else if (link) {
    ctaType = includes(className, 'is-disabled') || disabled ? null : React.createElement(SlicesItem.Text, {
      asTag: "a",
      className: ctaClasses,
      disabled: isDisabled
    }, link);
  } else if (price) {
    ctaType = price;
  } else if (customHtml) {
    ctaType = customHtml;
  } else {
    ctaType = includes(className, 'is-disabled') || disabled ? null : React.createElement(Icon, {
      name: "ui-arrow-right-r"
    });
  }

  var handleClickSlice = function handleClickSlice(e) {
    if (disabled) {
      e.preventDefault();
      return false;
    }

    if (typeof onClick === 'function') onClick(e);
  };

  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: _Tag,
      isNestedInlink: Tag === 'a'
    }
  }, React.createElement(_Tag, _extends({
    className: sliceClasses
  }, others, {
    onClick: function onClick(e) {
      return handleClickSlice(e);
    }
  }), icon && React.createElement("div", {
    className: "slice-icon"
  }, React.createElement(Icon, {
    name: icon,
    className: iconClassName
  })), React.createElement("div", {
    className: contentClasses
  }, title && React.createElement(Title, {
    className: titleClasses,
    size: 6
  }, title), children && typeof children.valueOf() === 'string' ? React.createElement(SlicesItem.Text, {
    asTag: "div",
    content: children
  }) : children), React.createElement("div", {
    className: sliceCTAClasses
  }, ctaType)));
};

SlicesItem.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  cta: PropTypes.string,
  link: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  ctaClassName: PropTypes.string,
  ctaDisabled: PropTypes.bool,
  sliceCTAClassName: PropTypes.string,
  icon: PropTypes.string,
  iconClassName: PropTypes.any,
  contentClassName: PropTypes.string,
  title: PropTypes.any,
  titleClassName: PropTypes.string,
  price: PropTypes.element,
  customHtml: PropTypes.any,
  onClick: PropTypes.func,
  asTag: PropTypes.string
};
SlicesItem.Text = Text;
SlicesItem.displayName = 'Slices.Item';
SlicesItem.defaultProps = {
  asTag: 'div'
};
export default withModifiers(SlicesItem);